export default "__VITE_ASSET__b736fd97__"